import { createSelector } from "reselect"
import { StateWithStatus, Status } from "../reducers"

const statusSelector = (state: StateWithStatus) => state.status
export const hasFailed = createSelector(
  statusSelector,
  (status: Status) => status === Status.FAILED
)
